import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { browserName, browserVersion } from 'react-device-detect';
import Switch from 'react-switch';
import "react-toggle/style.css"
import UserContext from '../tools/contextLib';
import  AthKeycardAthlete  from './athKeycardFold/athKeycardAthlete';
import AthKeycardGA from './athKeycardFold/athKeycardGA';
import  AthKeycardFitness from './athKeycardFold/athKeycardFitness';
import { Form, Input, FormGroup, Label } from 'reactstrap';
import moment from 'moment';
import { connect } from 'react-redux';

class AthleteKeycard extends Component {
    static displayName = AthleteKeycard.name;

    constructor(props) {
        super(props);
        this.state = {
            returnable: this.props.reduxData.userInfo,
            browser: `${browserName}${browserVersion}`,
            ip: "",
            switchState: "athlete",
            showPage: false,
            sportsList: []
        }
        this.testPermission();
        this.getSports()
    }

    //async getData() {
    //    const response = await fetch('https://api.ipify.org?format=json', { dataType: 'jsonp' });
    //    const data = await response.json();
    //    this.setState({
    //        ip: data.ip
    //    })
    //    this.getUserInfo();
    //}

    //async getUserInfo() {
    //    //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
    //    let bearerVAR = "Bearer " + this.props.reduxData.apiKey
    //    this.props.updateFetchTime();
    //    fetch('user', { method: 'GET', headers: { 'Authorization': bearerVAR } })
    //        .then((response) => response.json())
    //        .then((responseJSON) => { this.writeUserData(responseJSON) })
    //        //.then((responseLog) => { this.recordComingHere() })
    //        .then((responseState) => { this.testPermission() })
    //    //localStorage.setItem("lastFetch", moment());
    //    this.writeUserData(this.props.reduxData.userInfo)
    //}

    //writeUserData(input) {
    //    this.setState({
    //        returnable: input,
    //        showPage: true
    //    })
    //    this.getSports();
    //}



    async testPermission() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            pagepk: "1038"
        }
        const response = await fetch('ValidDepartments', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            permissionFlag: data
        })
    }

    async getSports() {
        //let bearerVAR = "Bearer " + localStorage.getItem("webApiAccessToken");
        let bearerVAR = "Bearer " + this.props.reduxData.apiKey
        this.props.updateFetchTime();
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk
        }
        const response = await fetch('SportsKeycard', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': bearerVAR },
            body: JSON.stringify(toSend)
        })
        const data = await response.json();
        //localStorage.setItem("lastFetch", moment());
        this.setState({
            sportsList: data,
            showPage:true
            })
    }

    componentDidMount() {

    }

    //toggleSwitch() {
    //    this.setState({
    //        switchState: !this.state.switchState
    //        })
    //}

    changeActive(fresh) {
        this.setState({
            switchState: fresh
        })
    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //if (this.props.justSwitch == true) {
        //    this.props.passNewPage(1);
        //}
        let displayPage = <div></div>
        switch (this.state.switchState) {//The first time a switch case is used for this project, and while I don't like the look of break; here it shouldn't be the last. It works really well.
            case "athlete":
                displayPage = <AthKeycardAthlete userData={this.props.reduxData.userInfo} sportsList={this.state.sportsList} />
                break;
            case "ga":
                displayPage = <AthKeycardGA userData={this.props.reduxData.userInfo} sportsList={this.state.sportsList} />
                break;
            case "fitness":
                displayPage = <AthKeycardFitness userData={this.props.reduxData.userInfo} />
                break;
            default:
                displayPage = <div></div>
                break;
        }
        return (
            <UserContext.Consumer>
                {contextData => (
                    <div>
                        <div className='d-flex float-right' style={{ float: 'right' }}>
                            <Form className="rightAlignCustom">
                                <FormGroup check inline>
                                    &nbsp;<Input checked={this.state.switchState == "ga" ? true : false} type="radio" name="activeFlip" id="activeFlip" onChange={() => this.changeActive("ga")} /><Label>GA</Label>
                                </FormGroup>
                                <FormGroup check inline>
                                    &nbsp;<Input type="radio" checked={this.state.switchState == "athlete" ? true : false} name="activeFlip" id="activeFlip" onChange={() => this.changeActive("athlete")} /><Label>Athlete</Label>
                                </FormGroup>

                                {!this.state.lockScheduling && <FormGroup check inline>
                                    <Input type="radio" checked={this.state.switchState == "fitness" ? true : false} name="activeFlip" id="activeFlip" onChange={() => this.changeActive("fitness")} /><Label>Fitness</Label>
                                </FormGroup>}
                            </Form>
                        </div>
                        {this.state.showPage && displayPage}
                    </div>
                )}
            </UserContext.Consumer>
            );
    }
}


const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(AthleteKeycard);